import { createFileRoute } from "@tanstack/react-router";
import AdminSalesPitches from "@/pages/admin/AdminSalesPitches";

export const Route = createFileRoute("/_adminLayout/admin/sales-pitches")({
  component: AdminSalesPitches,
});
